export const fetchCheckout = (checkout) => dispatch => {
  dispatch({
    type: 'FETCH_CHECKOUT',
    payload: checkout,
  })
 }